const {h, render, Component} = require('preact');

class CallUsView extends Component {
  constructor(props) {
    super(props);
    this.handleClosePopupEvent = this.handleClosePopupEvent.bind(this);
  }

  handleClosePopupEvent() {
    this.props.handleCallUsClose();
  }

  render() {
    return (
      <div id="call-us-pane">
        <div class="call-us-pane">
          <div>
            <span class="icon-x" onClick={this.handleClosePopupEvent}></span>
          </div>
          <div className="call-us">
            {I18n.translate('js.modules.shared.call_us')}
          </div>
          <div class="description">
            {I18n.translate('js.modules.shared.talk_to_us')}&nbsp;
            {I18n.translate('js.modules.shared.call_us_phone')}&nbsp;
            <br></br>
            {I18n.translate('js.modules.shared.call_us_available')}&nbsp;
            {I18n.translate('js.modules.shared.call_us_time')}
          </div>
        </div>
      </div>

    )
  }
}

module.exports = CallUsView
